import { render, staticRenderFns } from "./ListVehicleType.vue?vue&type=template&id=5038a3b5&"
import script from "./ListVehicleType.vue?vue&type=script&lang=js&"
export * from "./ListVehicleType.vue?vue&type=script&lang=js&"
import style0 from "./ListVehicleType.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports